export default __webpack_public_path__ + "static/media/logo-endeavor 1.6b6f4955.svg";